import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const getLocaleFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

const COAInputForm = () => {
  const [code, setCode] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const locale = getLocaleFromCookie();

  const handleChange = (e) => {
    const value = e.target.value.replace(/\s/g, "");
    if (/^[A-Za-z0-9]{0,16}$/.test(value)) {
      setCode(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.length === 16) {
      navigate(`/coa/${code}`);
    }
  };

	
  return (
    <div className="container mt-5 mt-xl-10">
      <form onSubmit={handleSubmit} className="mt-4">
        <div className="row g-0">
          <div className="col-12 col-md-9 mb-3 mb-md-0">
            <input
              type="text"
              value={code}
              onChange={handleChange}
              maxLength="16"
              placeholder={t("coaVerification.placeholder", "Enter 16-digit code")}
              className="form-control text-start fs-4"
              style={{
                letterSpacing: "0.3rem",
                fontFamily: "monospace",
              }}
              aria-label={t("coaVerification.ariaLabel", "16-character certificate code")}
            />
          </div>
          <div className="col-12 col-md-3">
            <button
              type="submit"
              className="btn btn-dark w-100 h-100 fs-5"
              disabled={code.length !== 16}
            >
              {t("coaVerification.verify", "Verify")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default COAInputForm;
